/* eslint-disable react/no-unescaped-entities */
import * as React from 'react'
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react'
import { Routes, Route } from 'react-router-dom'
import { UnauthenticatedPage } from './security/unAuthenticatedPage'
import { useAuthContext } from './security/AuthContext'
import { ToastContainer } from 'react-toastify'
import BrockRoutes from './components/navigation/BrockRoutes'
import BrockLimitedRoutes from './components/navigation/BrockLimitedRoutes'
import ScaffoldRequestPage from './pages/ScaffoldRequestPage'
import PublicLayout from './components/layout/PublicLayout'

export default function App() {
	const { hasWpaToken } = useAuthContext()

	return (
		<>
			<Routes>
				{/* Public route that doesn't require authentication */}
				<Route path='/request/:projectId' element={<PublicLayout />} >
					<Route index element={<ScaffoldRequestPage />} />
				</Route>

				{/* Authenticated routes */}
				<Route
					path='/*'
					element={
						<>
							<AuthenticatedTemplate>
								{hasWpaToken() ? <BrockRoutes /> : <BrockLimitedRoutes />}
							</AuthenticatedTemplate>
							<UnauthenticatedTemplate>
								<UnauthenticatedPage />
							</UnauthenticatedTemplate>
						</>
					}
				/>
			</Routes>

			<ToastContainer
				position='bottom-right'
				autoClose={2500}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
				theme='colored'
			/>
		</>
	)
}
